import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSinglePassHeatExchanger = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 90,
	height: 30,
	viewBox: "0 0 90.0 30.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 30.0 L 15.0 30.0 L 15.0 24.0 L 75.0 24.0 L 75.0 30.0 L 90.0 30.0 L 90.0 0.0 L 75.0 0.0 L 75.0 6.0 L 15.0 6.0 L 15.0 0.0 L 0.0 0.0 Z M 15.0 6.0 L 15.0 24.0 M 75.0 6.0 L 75.0 24.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgSinglePassHeatExchanger;
